import InProgressCard from "../../components/SuggestCards/InprogressCard";
import GroupedCampaignTab from "./GroupedCampaignTab";

export default function GroupedOfferingTab({ list, lastItemRef, loading, onChanged }) {
  return (
    <GroupedCampaignTab
      list={list}
      lastItemRef={lastItemRef}
      renderItem={(item) => <InProgressCard item={item} onChanged={onChanged} />}
      itemKey={(item) => item.proposalId ?? item.campaignId}
      countLabel="제안서"
      loading={loading}
    />
  );
}
